import { TenantDTO } from 'probonio-shared-ui/api';
import { CircularProgressBar } from 'probonio-shared-ui/component/progress';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useMemo } from 'react';
import { FullWidthCenterBox } from '../../../component/layout/BoxLayout';
import ITLeasingInfoPanel from './ITLeasingInfoPanel';

export interface BenefitPrecondition {
  isPreconditionMet: boolean;
  PreconditionComponent: React.ReactNode;
}

export function isITLeasingPreconditionMet(tenant: TenantDTO | undefined): boolean {
  return !!tenant?.itLeasingCompanyLink;
}

export function useITLeasingPrecondition(): BenefitPrecondition {
  const { tenant, isLoading } = useTenant();
  const isPreconditionMet = isITLeasingPreconditionMet(tenant);

  const component = useMemo(
    () =>
      isLoading ? (
        <FullWidthCenterBox>
          <CircularProgressBar />
        </FullWidthCenterBox>
      ) : (
        <ITLeasingInfoPanel />
      ),
    [isLoading],
  );

  return useMemo(() => ({ isPreconditionMet, PreconditionComponent: component }), [component, isPreconditionMet]);
}
